import axios from 'axios';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {emailChange, emailErrorChange, loadingChange, setSignFlag } from '../../../redux/slices/AuthSlice';
import { URL } from '../../../config';
import { setErrorMessage, setSuccessMessage } from '../../../redux/slices/MessageSlice';

const EmailForm = () => {
    const {emailError}=useSelector((state)=>state.AuthReducer);
    const [email,setEmail]=useState('');
    const dispatch = useDispatch();
    const emailHandel =(e)=>{
        setEmail(e.target.value);
        dispatch(emailErrorChange(""));   
    }
    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
      }
    
    const sendCode =(e)=>{
        e.preventDefault();
        if (!isValidEmail(email)) {
            dispatch(emailErrorChange("- تأكد من صحة البريد الإلكتروني"));
            return;
        }
        dispatch(loadingChange());
        axios.post(`${URL}/api/auth/email_verification`, {
         email: email,
       }) .then(function (response) {
         if(response.data.success){
            dispatch(emailChange(email));
            dispatch(setSuccessMessage('تم ارسال رمز التحقق'));
            dispatch(setSignFlag(1));
             }
             else{
                dispatch(emailErrorChange(response.data.data.email[0]));
                dispatch(setErrorMessage(response.data.data.email[0]));
                console.log(response.data.data.email[0]);
             }
             dispatch(loadingChange());
           })
       .catch(function (error) {
         console.log('error');
      dispatch(loadingChange());

       });
        
       } 
  return (
    <form onSubmit={sendCode} style={{ marginTop:"50px" }}>
        <label for="email">البريد الإلكترونى</label>
        <input style={{ borderColor:emailError&&'red',color:emailError&&'red' }} type='email' id="email" value={email} onChange={emailHandel} placeholder='your@email.com'/>
        <p style={{ position:'absolute',color:'red',fontSize:'12px' }}>{emailError}</p>
        <input type='submit' style={{ marginTop:"40px" }}   value="التالى"/>
    </form>
  )
}

export default EmailForm
